import { createTheme } from '@mui/material/styles';

import arrowUpRightIcon from 'images/icons/arrow_up_right.svg';

import breakpoints from './breakpoints';
import { getColor } from './colors';
import { remCalc } from './remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
});

const mixins = {
	glass: {
		background: 'rgba(255, 255, 255, .2)',
		boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
		backdropFilter: 'blur(15px)',
	},
	button: {
		fontFamily: 'var(--font-brandon-grotesque)',
		fontSize: remCalc(20),
		lineHeight: remCalc(24),
		fontWeight: 400,
		letterSpacing: '2px',
		color: `${getColor('ivory', 800)}`,
		a: {
			color: `${getColor('ivory', 800)}`,
		},
	},
	button_small: {
		fontFamily: 'var(--font-brandon-grotesque)',
		fontSize: remCalc(16),
		lineHeight: remCalc(20),
		fontWeight: 400,
		letterSpacing: '0.5px',
		color: `${getColor('ivory', 800)}`,
		a: {
			color: `${getColor('ivory', 800)}`,
		},
	},
	button_outlined: {
		fontFamily: 'var(--font-brandon-grotesque)',
		fontSize: remCalc(16),
		lineHeight: remCalc(20),
		fontWeight: 400,
		letterSpacing: '2px',
		borderColor: getColor('ivory', 800),
		color: `${getColor('ivory', 800)}`,
		a: {
			color: `${getColor('ivory', 800)}`,
		},
		padding: remCalc('8 20'),
	},
	button_underlined: {
		fontFamily: 'var(--font-brandon-grotesque)',
		fontSize: remCalc(16),
		lineHeight: remCalc(20),
		fontWeight: 400,
		letterSpacing: '2px',
		color: `${getColor('ivory', 800)}`,
		a: {
			color: `${getColor('ivory', 800)}`,
		},
		textDecoration: 'underline',
		textUnderlineOffset: remCalc(10),
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	button_dialog_dark: {
		fontFamily: 'var(--font-brandon-grotesque)',
		fontSize: remCalc(16),
		lineHeight: remCalc(20),
		fontWeight: 420,
		letterSpacing: '2px',
		color: `${getColor('ivory', 800)}`,
		background: 'rgba(255, 255, 255, 0.35)',
		a: {
			color: `${getColor('ivory', 800)}`,
		},
		'&:hover': {
			background: 'white',
		},
	},
	button_dialog_light: {
		fontFamily: 'var(--font-brandon-grotesque)',
		fontSize: remCalc(16),
		lineHeight: remCalc(20),
		fontWeight: 420,
		letterSpacing: '2px',
		color: 'white',
		background: 'rgba(255, 255, 255, 0.35)',
		a: {
			color: 'white',
		},
		'&:hover': {
			background: 'white',
		},
	},
	layout_styles: {
		marginBottom: remCalc(50),
		'&.padding-normal': {
			paddingTop: remCalc(30),
			paddingBottom: remCalc(30),
			[theme.breakpoints.up('sm')]: {
				paddingTop: remCalc(100),
				paddingBottom: remCalc(100),
			},
		},
		'&.padding-large': {
			paddingTop: remCalc(80),
			paddingBottom: remCalc(80),
			[theme.breakpoints.up('sm')]: {
				paddingTop: remCalc(160),
				paddingBottom: remCalc(160),
			},
		},
		'&.margin-flush': {
			marginBottom: 0,
		},
	},
	bold_arrow: {
		display: 'inline-flex',
		alignItems: 'center',
		fontFamily: 'var(--font-brandon-grotesque)',
		fontSize: remCalc(16),
		fontWeight: 420,
		lineHeight: 1.25,
		letterSpacing: 2,
		textTransform: 'uppercase',
		textDecoration: 'none',
		color: getColor('ivory', 600),
		borderBottom: `1px solid transparent`,
		transition: 'all var(--transition-duration) ease-in',
		'> svg': {
			width: remCalc(10),
			marginLeft: remCalc(20),
		},
		'&:hover': {
			borderBottomColor: getColor('ivory', 800),
		}
	}
}

export default mixins;